import React from 'react'
import AnswerSheet from "./components/AnswerSheet";
import {getAnswerSheetDataFromQuizData} from "./utils/answer-sheet-data";
import {getDateWithTime} from "../shared/utils/get-date-with-time";
import MaterialButton from "../shared/components/MaterialButton";
import {isMobileOnly} from "react-device-detect";
import {createRoot} from "react-dom/client";
import STATUS_PAGE_PATH from "../status-page-path";

if (quizAnswerData.quizAnswerData === "NOT FOUND") {
    let quizId
    const desired_value = new URL(window.location.href).pathname.split('/')[2]
    for (let i = 0, len = localStorage.length; i < len; i++) {
        let key = localStorage.key(i);
        let value = localStorage[key];
        if (value === desired_value) {
            quizId = key.split("_")[0]
            localStorage.removeItem(key)
        }
    }
    if (quizId) {
        location.replace("/id/" + quizId);
    } else {
        location.replace(STATUS_PAGE_PATH.ERROR);
    }
}

const quizUserInfoHints = quizAnswerData.quizQuestionData.quiz_data.user_info;
const quizUserInfoAnswers = quizAnswerData.quizAnswerData.quiz_data.user_info;
let inputData = getAnswerSheetDataFromQuizData(quizAnswerData.quizAnswerData, quizAnswerData.quizQuestionData.pages[0].questions);
const domContainer = document.querySelector("#root");

/*
let url = new URL(location.href);
let userId = url.searchParams.get("user");
if (userId !== null) {
    localStorage.setItem('USER_ID', userId);
} else {
    userId = localStorage?.getItem('USER_ID')
    if (userId === null) {
        alert('User Id is Required! \n Example: xyz.com/app?user=rjeyakumar92@gmail.com#dashboard')
    }
}
*/

const answerSheet = createRoot(domContainer);
answerSheet.render(<React.Fragment>
    <FormTitleContainer/>
    <AnswerSheet isQuizEdit={false}
                 isQuiz={true}
                 userId={quizAnswerData.quizQuestionData.user_id}
                 responseCount={1}
                 subscriptionData={quizAnswerData.quizQuestionData.subscription_data}
                 isQuizV2={quizAnswerData.quizQuestionData.is_quizzory_v2}
                 individualResponderQuestionWiseData={inputData ? inputData.individualResponderQuestionWiseData : null}
                 quizResults={inputData ? inputData.quizResults : null}
                 isPublish={quizAnswerData.quizQuestionData.is_publish}
                 isEvaluating={quizAnswerData.quizAnswerData ? quizAnswerData.quizAnswerData.is_evaluating : false}
                 showQuizCorrectAnswer={(quizAnswerData.quizQuestionData.setting && quizAnswerData.quizQuestionData.setting.is_show_correct_answer)
                     ? quizAnswerData.quizQuestionData.setting.is_show_correct_answer : false}/>
    {isMobileOnly ? <div className="print-fab">
        <div style={{
            opacity: '0.5', height: '48px', width: '48px', borderRadius: '50%',
            backgroundColor: '#004ba0', display: 'flex', margin: '4px', alignItems: 'center', justifyContent: 'center'
        }} onClick={() => window.print()}>
            <img alt='print' align="middle" src="../../images/print_icon.svg"
                 className="image_icon"/>
        </div>
    </div> : null}
</React.Fragment>, domContainer);

function GetSpanElement(props) {
    return (
        <span className={props.className ? props.className : null}
              style={props.textColor ? {color: props.textColor} : null}>{props.innerText ? props.innerText : ''}</span>
    )
}

function FormTitleContainer () {
    return (
        <div className='answer-sheet-form-title-container'>
        <span className='quiz-title-text'>
            {quizAnswerData.quizQuestionData.welcome_screen.title ?
                quizAnswerData.quizQuestionData.welcome_screen.title : ""}</span>
            <div className='individual-response-header'>
                <div className='response-count-container'>
                    {quizUserInfoHints && quizAnswerData.quizAnswerData && quizAnswerData.quizQuestionData.is_quiz ?
                        <div className='individual-quiz-header'>
                            {quizUserInfoHints.user_info_1 ?
                                <GetSpanElement className='user-info-title'
                                                innerText={quizUserInfoHints.user_info_1 + ':  ' + (quizUserInfoAnswers.user_info_1 ? quizUserInfoAnswers.user_info_1 : ' -')}
                                />
                                : null}
                            {quizUserInfoHints.user_info_2 ?
                                <GetSpanElement className='user-info-title'
                                                innerText={quizUserInfoHints.user_info_2 + ':  ' + (quizUserInfoAnswers.user_info_2 ? quizUserInfoAnswers.user_info_2 : ' -')}
                                /> : null}
                            {quizUserInfoHints.user_info_3 ?
                                <GetSpanElement className='user-info-title'
                                                innerText={quizUserInfoHints.user_info_3 + ':  ' + (quizUserInfoAnswers.user_info_3 ? quizUserInfoAnswers.user_info_3 : ' -')}
                                /> : null}
                            {isMobileOnly ? <GetSpanElement className='response-time'
                                                            color='#9e9e9e'
                                                            innerText={quizAnswerData && quizAnswerData.quizAnswerData ? getDateWithTime(quizAnswerData.quizAnswerData.submit_time) : '--:--'}/> : null}
                        </div>
                        : <span className='response-time'>
                {quizAnswerData && quizAnswerData.quizAnswerData ? getDateWithTime(quizAnswerData.quizAnswerData.submit_time) : '--:--'}
            </span>
                    }
                </div>
                {!isMobileOnly ? <div className='right-aligned-container'>
                    <div className='print-button'>
                        <MaterialButton data={{
                            title: isMobileOnly ? '' : "Print", imageFileName: 'print_icon.svg',
                            bg_color: '#004ba0',
                            customButtonContainerStyle: {
                                minWidth: '0',
                                padding: '0 10px 0 15px'
                            }, customImageStyle: {
                                marginRight: (isMobileOnly ? '0' : '8px')
                            }
                        }} handleClick={() => window.print()}/>
                    </div>
                    {quizAnswerData.quizQuestionData.is_quiz && !isMobileOnly ? <span className='response-time'>
                {quizAnswerData.quizAnswerData ?
                    (isMobileOnly ? '' : 'Submitted Time : ') + getDateWithTime(quizAnswerData.quizAnswerData.submit_time) : '--:--'}
            </span> : null}
                </div> : null}

            </div>
        </div>
    )
}
